"use strict";
import { addEvent } from "../addEvent/addEvent";
import { isMobile } from "../isMobile/isMobile";

export const mainPageBaner = class {
  mainTxtContainer = false;
  ulTxtContainer = false;

  contentContainer = false;
  inProgress = false;
  curentElement = 0;
  elementsTxt = [];

  contentContainerClass = "main-page-baner__show-container";
  showContainer_contentContainer = "show-container__contentContainer";

  mainContainerAnimationClass = "main-page-baner--animation";
  inAnimationClass = "main-page-baner__in-animation";
  outAnimationClass = "main-page-baner__out-animation";

  slideControlContainerClass = "main-page-baner__slides-control";
  slideControlChangeSlideButtonClass = "slides-control__change-slide";
  slideControlChangeSlidePrevButtonClass = "slides-control__change-slide--prev";
  slideControlChangeSlideNextButtonClass = "slides-control__change-slide--next";

  autoChange = true;
  autoChangeTime = 14000;
  autoChangeTimer = false;
  inAnimationTime = 750;
  outAnimationTime = 1000;

  touchstartx = undefined;
  touchmovex = undefined;
  movex = undefined;
  longTouch = undefined;

  constructor(mainTxtContainer) {
    if (!mainTxtContainer) {
      return false;
    }

    this.mainTxtContainer = mainTxtContainer;
    this.ulTxtContainer = mainTxtContainer.getElementsByTagName("ul")[0];

    if (!this.ulTxtContainer) {
      return false;
    }

    this._start();
    return this;
  }

  _start = () => {
    const { curentElement, mainTxtContainer, _moveMouseReadInit } = this;
    this.mainTxtContainer.classList.add(this.mainContainerAnimationClass);
    this._addContetnContainer(this.mainTxtContainer);
    this._setElements();
    this._createSlidesControl();
    this._displayElement(curentElement);
    this._touchInit();
    /*
    this._moveMouseReadInit();

    addEvent(window, "resize", () => {
      mainTxtContainer.removeEventListener("mousemove", _moveMouseReadInit, {
        passive: true,
      });
      _moveMouseReadInit();
    });
    */
  };

  _setElements = () => {
    this.elementsTxt = this.ulTxtContainer.querySelectorAll("li");
  };

  _createSlidesControl = () => {
    const {
      mainTxtContainer,
      curentElement,
      elementsTxt,
      elementsImg,
      slideControlContainerClass,
      slideControlChangeSlideButtonClass,
      slideControlChangeSlidePrevButtonClass,
      slideControlChangeSlideNextButtonClass,
      _slidesPrevNextControlClick,
    } = this;

    if (elementsTxt.length < 2) {
      return;
    }

    let controlContainer = document.createElement("div");
    controlContainer.classList.add(slideControlContainerClass);

    const prevSlideButton = document.createElement("div");
    prevSlideButton.classList.add(slideControlChangeSlideButtonClass);
    prevSlideButton.classList.add(slideControlChangeSlidePrevButtonClass);
    _slidesPrevNextControlClick(prevSlideButton, -1);

    controlContainer.insertBefore(prevSlideButton, controlContainer.firstChild);

    let nextSlideButton = document.createElement("div");
    nextSlideButton.classList.add(slideControlChangeSlideButtonClass);
    nextSlideButton.classList.add(slideControlChangeSlideNextButtonClass);
    _slidesPrevNextControlClick(nextSlideButton, 1);
    controlContainer.appendChild(nextSlideButton);

    mainTxtContainer.appendChild(controlContainer);
  };

  _slidesPrevNextControlClick = (clikcElement, step) => {
    addEvent(clikcElement, "click", (e) => {
      const { elementsTxt, inProgress, _displayElement, _setInProgress } = this;

      if (inProgress) {
        return;
      }
      _setInProgress();

      let elementToShow = this.curentElement + step;
      if (elementToShow < 0) {
        elementToShow = elementsTxt.length - 1;
      }
      if (elementToShow >= elementsTxt.length) {
        elementToShow = 0;
      }

      _displayElement(elementToShow);
    });
  };

  _displayElement = (idx) => {
    this.elementsTxt[this.curentElement].classList.remove(
      this.inAnimationClass
    );
    this.elementsTxt[this.curentElement].classList.add(this.outAnimationClass);

    setTimeout(() => {
      this.elementsTxt[this.curentElement].classList.remove(
        this.outAnimationClass
      );
    }, this.outAnimationTime);

    this.elementsTxt[idx].classList.remove(this.outAnimationClass);
    this.elementsTxt[idx].classList.add(this.inAnimationClass);

    let elm = this.elementsTxt[idx]
      .getElementsByClassName("main-page-baner__content")[0]
      .cloneNode(true);

    let row_1 = elm.getElementsByClassName("row__one")[0];
    if (row_1) {
      this._wrapElement(row_1, "span", "span-wraper");
    }

    let row_2 = elm.getElementsByClassName("row__two")[0];
    if (row_2) {
      this._wrapElement(row_2, "span", "span-wraper");
    }

    let row_3 = elm.getElementsByClassName("row__three")[0];
    if (row_3) {
      this._wrapElement(row_3, "span", "span-wraper");
    }

    let info = elm.getElementsByClassName("main-page-baner__more-info")[0];
    if (info) {
      this._wrapElement(info, "div", "span-wraper");
    }

    let wrapper = document.createElement("div");
    wrapper.classList.add(this.showContainer_contentContainer);
    wrapper.classList.add(this.inAnimationClass);
    wrapper.appendChild(elm);

    if (this.contentContainer.lastChild) {
      this.contentContainer.lastChild.classList.remove(this.inAnimationClass);
      this.contentContainer.lastChild.classList.add(this.outAnimationClass);
      setTimeout(() => {
        this.contentContainer.firstChild.remove();
      }, this.outAnimationTime);
    }

    this.contentContainer.appendChild(wrapper);

    /*
    this.contentContainer.style.height =
      wrapper.offsetHeight != 0 ? `${wrapper.offsetHeight}px` : "auto";
*/
    setTimeout(
      () => {
        this.curentElement = idx;
        this._startTimer();
      },
      this.outAnimationTime > this.inAnimationTime
        ? this.outAnimationTime
        : this.inAnimationTime
    );
  };

  _setInProgress = () => {
    let { inProgress, outAnimationTime, inAnimationTime } = this;

    if (inProgress === false) {
      this.inProgress = true;

      setTimeout(
        () => {
          this.inProgress = false;
        },
        outAnimationTime > inAnimationTime ? outAnimationTime : inAnimationTime
      );
    }
  };

  _addContetnContainer = (parent) => {
    this.contentContainer = document.createElement("div");
    this.contentContainer.classList.add(this.contentContainerClass);
    parent.prepend(this.contentContainer);
  };

  _wrapElement = (elm, htmlWraper, className) => {
    let wrapper = document.createElement(htmlWraper);
    if (className) {
      wrapper.classList.add(className);
    }
    elm.parentNode.appendChild(wrapper);
    wrapper.appendChild(elm);
  };

  _startTimer = () => {
    let { autoChange, autoChangeTime, autoChangeTimer, _changeSlideTimer } =
      this;

    if (!autoChange) {
      return;
    }
    clearTimeout(this.autoChangeTimer);
    this.autoChangeTimer = setTimeout(() => {
      _changeSlideTimer();
    }, autoChangeTime);
  };

  _changeSlideTimer = () => {
    const {
      elementsTxt,
      inProgress,
      _displayElement,
      _setInProgress,
      _startTimer,
      autoChangeTimer,
    } = this;
    const step = 1;

    if (inProgress) {
      return;
    }
    _setInProgress();

    let elementToShow = this.curentElement + step;
    if (elementToShow < 0) {
      elementToShow = elements.length - 1;
    }
    if (elementToShow >= elementsTxt.length) {
      elementToShow = 0;
    }

    _displayElement(elementToShow);

    setTimeout(
      () => {
        this._startTimer();
      },
      this.outAnimationTime > this.inAnimationTime
        ? this.outAnimationTime
        : this.inAnimationTime
    );
  };

  _touchInit = () => {
    const { mainTxtContainer, _touchChangeSlide } = this;

    mainTxtContainer.addEventListener(
      "touchstart",
      (e) => {
        this.touchstartx = e.changedTouches[0].pageX;

        this.longTouch = false;
        setTimeout(() => {
          this.longTouch = true;
        }, 100);
      },
      { passive: true }
    );

    mainTxtContainer.addEventListener(
      "touchmove",
      (e) => {
        this.touchmovex = e.changedTouches[0].pageX;
      },
      { passive: true }
    );

    mainTxtContainer.addEventListener(
      "touchend",
      (e) => {
        this.movex = this.touchstartx - this.touchmovex;

        if (this.longTouch && this.movex > 50) {
          _touchChangeSlide(1);
        }

        if (this.longTouch && this.movex < -50) {
          _touchChangeSlide(-1);
        }
      },
      { passive: true }
    );
  };

  _touchChangeSlide = (step) => {
    const { elementsTxt, inProgress, _displayElement, _setInProgress } = this;

    if (inProgress) {
      return;
    }
    _setInProgress();

    let elementToShow = this.curentElement + step;
    if (elementToShow < 0) {
      elementToShow = elementsTxt.length - 1;
    }
    if (elementToShow >= elementsTxt.length) {
      elementToShow = 0;
    }

    _displayElement(elementToShow);
  };

  _moveMouseReadInit = () => {
    const { _setMouseMoveToVar, mainTxtContainer } = this;

    mainTxtContainer.addEventListener("mousemove", _setMouseMoveToVar, {
      passive: true,
    });
  };

  _setMouseMoveToVar = (e) => {
    const { mainTxtContainer } = this;

    const maxAngelX = 20;
    const minAngleX = -20;
    const maxAngelY = 15;
    const minAngleY = -15;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const offsetX = e.clientX;
    const offsetY = e.clientY;

    let positionX = -50 + Math.ceil((offsetX * 100) / windowWidth);
    let positionY = 50 - Math.ceil((offsetY * 100) / windowHeight);

    positionX = positionX > maxAngelX ? maxAngelX : positionX;
    positionX = positionX < minAngleX ? minAngleX : positionX;
    positionY = positionY > maxAngelY ? maxAngelY : positionY;
    positionY = positionY < minAngleY ? minAngleY : positionY;

    mainTxtContainer.style.setProperty("--angleX", positionY + "deg");
    mainTxtContainer.style.setProperty("--angleY", positionX + "deg");
  };
};
